import React, { useState, useMemo } from "react";
import ConfirmationPopup from "../../../common/components/confirmation-popup/confirmation-popup";
import { massDeleteLeads, massUpdateLeads } from "../../../api/lead";
import { AlertComponent } from "../../../common/components";
import { useSetLoading } from "../../../common/hooks/appearance";
import { MassDeleteProps } from "./action-types";
import WarningIcon from '@mui/icons-material/Warning';
import { Typography, Box } from '@mui/material';
import ConfirmIcon from "../../../assets/icons/CreateLeadCapturePopupCancelIcon.svg";

const MassConvert: React.FC<MassDeleteProps> = ({
    leadsIds,
    setSelectedLeadsMap,
    isOpen,
    setMenuItems,
    selectedActions,
    setSelectedActions,
    fetchLeads,
    selectedLeadActionScope,
    setselectedLeadActionScope,
    totalRecords,
    handleMassActionMenuClose
}) => {
    const [alertMessage, setAlertMessage] = useState<string>("");
    const [alertType, setAlertType] = useState<"success" | "error">("success");
    const [alertOpen, setAlertOpen] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);  // ✅ Loading state

    const handleClose = () => {
        setMenuItems((prevItems) =>
            prevItems.map((item) =>
                item.value === selectedActions ? { ...item, isOpen: !item.isOpen } : item
            )
        );
        handleMassActionMenuClose()
    };
    const formatPayLoad = () => {
        const data = {
            leadsIds: leadsIds,
            fieldToUpdate: { ['leadStatus']: 'Converted' }
        }
        return data;
    }

    const handleUpdate = async () => {
        setLoading(true);
        let response;
        try {
            response = await massUpdateLeads(formatPayLoad())
            if (response?.status === 200) {
                setAlertMessage(`${leadsIds?.length === 1 ? 'Lead' : 'Leads'} conversion successful ! ${leadsIds?.length} ${leadsIds?.length === 1 ? 'lead' : 'leads'} have been successfully converted`);
                setAlertType("success");
                setselectedLeadActionScope("All Leads");
                setSelectedLeadsMap({});
                fetchLeads();
            }
        } catch (error: any) {
            setAlertMessage(error?.response?.data?.message ||  "An error occurred while saving the lead.");
            setAlertType("error");
            setAlertOpen(true);
        } finally {
            setLoading(false);
            setAlertOpen(true);
            handleClose()
        }
    };

    const showLoading = useMemo(() => isLoading, [isLoading]);
    useSetLoading(showLoading);
    return (
        <>
            {/* {loading && <Loader />}   */}

            <ConfirmationPopup
                open={isOpen}
                title={(leadsIds?.length === 1) ? "Convert Lead" : "Convert Leads"}
                note={
                    <Box display="flex" alignItems="center" gap={1}>
                        <WarningIcon color="warning" />
                        <Typography variant="body2">
                        Are you sure you want to convert{' '}
                            {
                                leadsIds?.length === 1 ? (
                                    <strong>the selected lead</strong>
                                ) : (
                                    <strong>the selected lead(s)</strong>
                                )
                            }
                            ? This action will update their status to <strong>Converted</strong>.
                        </Typography>
                    </Box>
                }
                buttonText="Convert"
                onCancel={handleClose}
                onOkay={handleUpdate}
                Icon={ConfirmIcon}
            />

            <AlertComponent
                message={alertMessage}
                type={alertType}
                open={alertOpen}
                onClose={() => setAlertOpen(false)}
            />
        </>
    );
};

export default MassConvert;